<template>
   <el-tabs :value="activeItem" type="card" @tab-remove="closeTab" class='content-body' @tab-click="tabClick" :before-leave="handleBeforeLeave">
        <!-- <el-tab-pane label="首页" name="adminIndex">
            <admin-index></admin-index>
        </el-tab-pane> -->
        <el-tab-pane v-for="item in tabs" :label="item.label" :key="item.index" :name="item.index"  :closable="item.closable">            
            <template v-if="item.label == '卡片详情' || item.label == '卡片信息'">
              <async-component v-if="refreshFlag" :componentPath='item.component'></async-component>
            </template>
            <template v-else>
              <async-component :componentPath='item.component'></async-component>
            </template>
        </el-tab-pane>
   </el-tabs>
</template>

<script>
// import AdminIndex from "../AdminIndex";
import { mapActions, mapState,mapMutations } from "vuex";
import AsyncComponent from "./async/AsyncComponent";

export default {
  data(){
    return {
      refreshFlag: true
    }
  },
  computed: {
    ...mapState("menu", {
      tabs: "tabs",
      activeItem: "activeItem"
    })
  },
  methods: {
    ...mapActions("menu", {
      closeTab: "closeTab"
    }),
    ...mapMutations("menu",{
      switchTab:"switchTab"
    }),
    tabClick(e){
      this.switchTab(e.name)
    },
    handleBeforeLeave(activeName, oldActiveName){
      var fromPage = this.$store.state.menu.fromPage;
      var arr = ['cardMgt', 'cardList', 'endTimeList', 'endTimeMgt']; 
      if(arr.indexOf(fromPage) != -1){
        this.refreshFlag = false
      }
      this.$nextTick(() => {
        this.refreshFlag = true;
      })
    }
  },
  components: {
    // AdminIndex,
    AsyncComponent
  }
};
</script>
<style scoped>
.content-body {
  height: 100%;
}
</style>


